import { FC } from "react";
import { InfoCircle } from "untitledui-js-base";

type ReportAlertMessageProps = {
  title: string;
  message?: string | null;
};

export const ReportAlertMessage: FC<ReportAlertMessageProps> = ({
  message,
  title
}) => {
  if (!message) return null;

  return (
    <div className="my-2 flex h-16 w-full items-center gap-4 rounded-lg border border-alpha-100 bg-warning-50">
      <div>
        <div className="flex h-11 w-12 items-center justify-center border-r border-alpha-80 pl-1">
          <InfoCircle className="h-5 w-5 stroke-warning-700" />
        </div>
      </div>
      <div className="gap-1">
        <p className="text-sm font-bold text-warning-700">{title}</p>
        <span className="text-sm font-medium text-warning-700">{message}</span>
      </div>
    </div>
  );
};
